module.exports = __webpack_public_path__ + "img/theme3.89895407.png";